/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentOverdueIndicator/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import Tysiav2Dollar from 'DesignSystem/Svgs/Tysiav2Dollar/index'



/** @type {import('Simple/types.js').View} */
export default function PaymentOverdueIndicator({
  children,
  viewPath = "/DesignSystem/PaymentOverdueIndicator",
  has_any_overdues,
  height = 14,
  width = 14,
  has_insurance_overdues,
  has_personal_overdues
  
}) {
let dtColorsBlue500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.500'
        })
let dtColorsRed500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.500'
        })
  return (<React.Fragment
>
<fromFlow.When is={has_any_overdues}>
<Tysiav2Dollar
  viewPath={`${viewPath}/Tysiav2Dollar`}
 height={height}
 width={width}
 fill2={has_insurance_overdues && has_personal_overdues ? dtColorsRed500 : has_insurance_overdues ? "#C99A2E" : dtColorsBlue500}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}